import { logSwallowed } from '@/lib/errors';
// ============================================================================
// ringtone.ts — звуки звонка через Web Audio (без внешних ассетов):
//   startRingback()     — исходящий «дозвон» (длинные гудки), пока не ответили;
//   startIncomingRing() — «входящий» (двойной тон);
//   stopRingtone()      — остановить любой из них.
// Идемпотентно; ошибки звука не роняют звонок (тихо игнорируются).
// ============================================================================

let ctx: AudioContext | null = null;
let timer: number | null = null;

function audioCtx(): AudioContext | null {
  try {
    if (!ctx) {
      const Ctor = window.AudioContext
        || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Ctor) return null;
      ctx = new Ctor();
    }
    if (ctx.state === 'suspended') void ctx.resume().catch((e) => { logSwallowed(e, 'lib/ringtone.ts:20'); return undefined; });
    return ctx;
  } catch {
    return null;
  }
}

function beep(freq: number, at: number, dur: number, vol = 0.1): void {
  const c = audioCtx();
  if (!c) return;
  try {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = 'sine';
    o.frequency.value = freq;
    o.connect(g);
    g.connect(c.destination);
    const t0 = c.currentTime + at;
    g.gain.setValueAtTime(0, t0);
    g.gain.linearRampToValueAtTime(vol, t0 + 0.03);
    g.gain.setValueAtTime(vol, t0 + Math.max(0.05, dur - 0.05));
    g.gain.linearRampToValueAtTime(0, t0 + dur);
    o.start(t0);
    o.stop(t0 + dur + 0.05);
  } catch {
    /* звук не критичен */
  }
}

export function startRingback(): void {
  if (timer != null) return;
  beep(425, 0, 1.0);
  timer = window.setInterval(() => beep(425, 0, 1.0), 3000);
}

export function startIncomingRing(): void {
  stopRingtone();
  const step = () => {
    beep(660, 0, 0.35);
    beep(880, 0.4, 0.35);
  };
  step();
  timer = window.setInterval(step, 2200);
}

export function stopRingtone(): void {
  if (timer != null) {
    clearInterval(timer);
    timer = null;
  }
}
